import React from 'react';

// Steam-Avatar, wenn wir einen haben -- sonst der Initialen-Kreis aus dem
// Design. Beide belegen exakt denselben Platz.
const Avatar = ({ src, initials, size = 40, font = 14, ring = null }) => {
  const base = {
    width: size,
    height: size,
    borderRadius: '50%',
    flex: 'none',
    display: 'grid',
    placeItems: 'center',
    // Der Ring trennt das Bild vom weissen Kartenhintergrund und faerbt es
    // dem Team zu, ohne das Foto selbst anzufassen.
    boxShadow: ring
      ? '0 0 0 2px #fff, 0 0 0 4px ' + ring + ', 0 6px 14px -8px rgba(31,64,32,.75)'
      : undefined,
  };

  if (src) {
    return <img src={src} alt="" style={{ ...base, objectFit: 'cover' }} />;
  }

  return (
    <div
      style={{
        ...base,
        background: '#e5efdd',
        color: '#3d6b3a',
        fontSize: font,
        fontWeight: 650,
      }}
    >
      {initials}
    </div>
  );
};

export default Avatar;
